import ImportPlatformComponent from 'pages/import/importPlatform';
import ImportPlatformsComponent from 'pages/import/importPlatforms';
import IntegrationsComponent from 'pages/integrations/integrations';
import OverviewComponent from 'pages/overview/overview';
import OverviewDetailsComponent from 'pages/overview/overviewDetails';
import OverviewSideComponent from 'pages/overview/overviewSide';
import BalanceCheckComponent from 'pages/balancecheck/balanceCheck';
import PartnerDetailsComponent from 'pages/partner/partnerDetails';
import PartnersComponent from 'pages/partner/partners';
import PartnersProComponent from 'pages/partner/partnersPro';
import Ui from 'pages/ui/ui';
import ValidationComponent from 'pages/validation/validation';
import { Route, Routes } from 'react-router-dom';
import OverviewSideDetailsComponent from 'pages/overview/overviewSideDetails';
import BalanceCheckDetailsComponent from 'pages/balancecheck/balanceCheckDetails';
import LedgerLiveSyncComponent from 'pages/ledgerlive/sync';

export default function RouteWrapper() {
  return (
    <Routes>
      <Route path="import-new" element={<ImportPlatformsComponent />} />
      <Route path="platform/:type/:id/:wallet" element={<ImportPlatformComponent />} />
      <Route path="platform/:type/:id" element={<ImportPlatformComponent />} />
      <Route path="partners" element={<PartnersComponent />} />
      <Route path="partners/:name" element={<PartnerDetailsComponent />} />
      <Route path="pro.php" element={<PartnersProComponent />} />
      <Route path="import" element={<IntegrationsComponent />} />
      <Route path="review" element={<ValidationComponent />} />
      <Route path="overview-v1" element={<OverviewComponent />} />
      <Route path="overview" element={<OverviewSideComponent />} />
      <Route path="overview/:name" element={<OverviewSideDetailsComponent />} />
      <Route path="balancecheck" element={<BalanceCheckComponent />} />
      <Route path="balancecheck/:name" element={<BalanceCheckDetailsComponent />} />
      <Route path="ledgerlive/sync" element={<LedgerLiveSyncComponent />} />
      <Route path="overview-v1/live/:type/:name/:wallet" element={<OverviewDetailsComponent liveOnly />} />
      <Route path="overview-v1/:type/:name/:wallet" element={<OverviewDetailsComponent />} />
      <Route path="overview-v1/:type/:name" element={<OverviewDetailsComponent />} />
      <Route path="overview-v1/:type/" element={<OverviewDetailsComponent />} />
      <Route path="ui" element={<Ui />} />
      <Route path="*" element={<p>Page not found!</p>} />

    </Routes>
  );
}
